import { styled } from 'styled-components';
import { PhotoUpload } from '@idaho-aeyc/ui-kit';

export const SPhotoUpload = styled(PhotoUpload)``;
